module.exports = __webpack_public_path__ + "static/demo-domain-company-a3b4b066f42ba55f62224d079b5e24a9.png";